module.exports = __webpack_public_path__ + "img/dai.a1c449c2.svg";